import React, { FC, memo } from 'react'

import { fromUnixTime, isFuture, isPast } from 'date-fns'

import { BodyText } from '@/containers/styles'
import { dateTranslation } from '@/i18n/dateTranslation'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import useStore from '@/store/useStore'
import { ChannelType, EventType } from '@/types/servicesTypes/configTypes'
import { getTimeFormat } from '@/utils/utils'

import { BodyTextWrapper, EventHeadingWrapper, StyledTitle } from './styles'

const VideoHeadingRaw: FC<{
  name?: string
  description?: string
  currentEvent?: Nullable<EventType>
  activeChannel?: ChannelType
  isHTMLWidget?: boolean
}> = (props) => {
  const {
    isHTMLWidget = false,
    description = '',
    activeChannel,
    currentEvent,
  } = props
  const { t } = useCommonTranslation()

  const mediaVideo = useStore((state) => state.common.mediaVideo)

  const start = currentEvent?.startTime
  const end = currentEvent?.endTime
  const startTime = start && fromUnixTime(start)
  const endTime = end && fromUnixTime(end)

  const isLiveNow = Boolean(
    startTime && endTime && isPast(startTime) && isFuture(endTime),
  )
  const timeFormat = getTimeFormat()

  const timeDate =
    startTime &&
    endTime &&
    dateTranslation(startTime, timeFormat) +
      ' - ' +
      dateTranslation(endTime, timeFormat)

  const channelBodyText = currentEvent ? timeDate : t('nowLive')

  const eventBodyText = currentEvent && isLiveNow && t('nowLive')

  const name =
    props.name !== undefined
      ? props.name
      : activeChannel
      ? currentEvent?.name || activeChannel?.name
      : mediaVideo?.name

  const bodyText =
    (activeChannel ? channelBodyText : eventBodyText) || description

  return (
    <EventHeadingWrapper>
      <StyledTitle>{name}</StyledTitle>
      {!isHTMLWidget && (
        <BodyTextWrapper>
          <BodyText>{bodyText}</BodyText>
        </BodyTextWrapper>
      )}
    </EventHeadingWrapper>
  )
}

export const VideoHeading = memo(VideoHeadingRaw)
